import { Component } from '@angular/core';
import { ModalService } from '../../shared/services/modal.service';

@Component({
  selector: 'ns-disclaimer',
  template: require('./disclaimer.component.html')
})
export class DisclaimerComponent {

  constructor(modal: ModalService) {
    this.modal = modal;
  }

  handleKeydown(event: KeyboardEvent, action: string, isPDF: boolean) {
    if (event.key === 'Enter') {
      this.clickFunction(action, isPDF);
    }
  }

  clickFunction(action, isPDF) {
    if (isPDF) {
      this.modal.pdfModal(action);
      return;
    }
    this.modal.interstitial(action);
  }
}
